<script setup lang="ts">
import ChooseGroup from '../../components/Class/ChooseGroup.vue';
import ClassDetails from '../../components/Class/ClassDetails.vue';
import RequestJoinClass from '../../components/Class/RequestJoinClass.vue';
import RaiseHand from '../../components/Control/RaiseHand.vue';
import { useClassStore } from '../../stores';
import { ClassStatus } from '../../types/class';
import Session from '../../components/Session/Session.vue';
import ScreenLock from '../../components/Notification/ScreenLock.vue';
import PointChanged from '../../components/Notification/PointChanged.vue';
import SessionChange from '../../components/Notification/SessionChange.vue';

const classStore = useClassStore()
classStore.getStudentClassDetails()
</script>

<template>
    <div v-if="classStore.selectedClassDetails"
        class="h-full flex-col flex flex-1 gap-3 rounded-lg bg-neutral-100 p-3 md:p-5 overflow-auto">
        <template v-if="classStore.selectedClassDetails.state === ClassStatus.not_started">
            <ClassDetails />
            <ChooseGroup />
        </template>
        <template v-if="classStore.selectedClassDetails.state === ClassStatus.on_going">
            <RequestJoinClass v-if="!classStore.selectedClassDetails.student_group_id" />
            <template v-else>
                <Session />
                <RaiseHand v-if="classStore.selectedClassDetails?.allowRaiseHand" />
                <PointChanged />
                <ScreenLock />
                <SessionChange />
            </template>
        </template>
    </div>
</template>